<template>
  <div class="redcat-configuration-container">
    <div class="header m-bottom-2rem">
      <span>Redcat configuration</span>
    </div>

    <template v-if="configurationStep == 1">
      <div class="content">
        <div class="field__wrapper">
          <span class="d-block m-bottom-10">Subdomain</span>
          <el-input v-model="form.subdomain" class="peiso-input-default center-align h-55 b-radius-10"></el-input>
        </div>
        <div class="field__wrapper">
          <span class="d-block m-bottom-10">Username</span>
          <el-input v-model="form.username" class="peiso-input-default center-align h-55 b-radius-10"></el-input>
        </div>
        <div class="field__wrapper">
          <span class="d-block m-bottom-10">Password</span>
          <el-input v-model="form.password" class="peiso-input-default center-align h-55 b-radius-10"></el-input>
        </div>
      </div>

      <div class="bottom-button d-flex gap-30">
        <el-button type="peiso-white-border-only w-100" @click="buttonAction('back')">Back</el-button>
        <el-button v-if="!loading" type="peiso-primary-pink-border-only w-100" @click="confirm">Confirm</el-button>
        <el-button v-if="loading" type="peiso-primary-pink-border-only w-100"><i class="el-icon-loading"></i>
          Loading...</el-button>
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
@import 'static/scss/colors.scss';
@import 'static/scss/fonts/fonts';
@import 'static/scss/scrollbar';

.redcat-configuration-container {

  .header {
    @include alata-fonts(28px, 150%, 500, $white)
  }

  .content {
    margin: 30px 0;

    .field__wrapper {
      @include alata-fonts(16px, normal, 400, $white) {
        padding: 10px 1rem;
      }

      border-style: solid;
      border-width: 1px 1px 0px 1px;
      border-color: $gray8;

      &:last-child {
        border-bottom-width: 1px;
      }


      .peiso-input-default {
        .el-input__inner {

          font-family: "Alata", sans-serif;
          font-weight: 500;
          font-size: 16px;
        }
      }
    }



  }

  .bottom-button {
    button {
      margin: 0px;
      font-family: "Alata", sans-serif;
      font-weight: 500;
      font-size: 26px;

    }
  }

  .configuration-two {
    span {
      @include alata-fonts(16px, normal, 400, $white)
    }

    .el-button--peiso-default {
      @include alata-fonts(16px, normal, 400, $white) {
        height: 55px;
        border-radius: 10px;
      }

    }

    .left-align {
      .el-button--peiso-default {
        display: flex;
        align-items: center;
        justify-content: left;
      }
    }

    .category-list {
      border-radius: 10px;
      background: $black2;
      min-height: 300px;
      max-height: 480px;
      overflow: hidden auto;

      &::-webkit-scrollbar {
        @extend .scrollbar;
      }

      &::-webkit-scrollbar-track {
        @extend .scrollbar-track;
      }

      &::-webkit-scrollbar-thumb {
        @extend .scrollbar-thumb;
      }
    }

  }
}
</style>

<script>
import api from '@/api/api';
import utils from '@/utils/utils';
export default {
  data() {
    return {
      form: {
        // subdomain: 'fondamexican',
        // username: 'ivan.brewer',
        // password: 'Ivan1234%^&*',
        subdomain: '',
        username: '',
        password: '',
        token: ''
      },
      configurationStep: 1,
      loading: false,
    }
  },
  methods: {

    buttonAction(action, data = null) {
      this.$emit(action, data)
    },

    async confirm() {
      this.loading = true
      // var formData = new FormData()
      // formData.append('username', this.form.username)
      // formData.append('psw', this.form.password)
      // formData.append('auth_type', 'U')
      // let url = `/api/v1/login`
      // let Api = axios.create({
      //     baseURL: `https://${this.form.subdomain}.redcatcloud.com.au`,
      //     withCredentials: true,
      //     origin: true,
      //     timeout: 600000, // 请求超时时间
      //     responseType: 'json',
      //     headers: {
      //         "Content-Type": "application/json",
      //         'Accept-Language': 'en-US'
      //     }
      // })
      // Api.post(url, formData).then((res) => {
      //     console.log(res)
      // })
      var token = ''
      setTimeout(() => {

        api.redcatBind({ subdomain: this.form.subdomain, username: this.form.username, password: this.form.password }).then((res) => {
          var result = res.data
          if (result.code == 0) {
            this.$emit('redcat-bind', true, result.data)
            utils.alert2('', 'Successfully connected to redcat.', 'success')
            this.buttonAction('back')
          } else {
            utils.alert2('', 'Error redcat binding configuration', 'error')
          }
          this.loading = false
        }).catch((err) => {
          utils.alert2('', err.response.data.message, 'error')
          this.loading = false
        })
      }, 2000);


    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/redcatConfiguration.vue